import React, { FunctionComponent } from 'react';
import { ReactComponent as CustomCardSVG } from '../../../images/svg/custom-card.svg';

const CustomCard: FunctionComponent = () => <CustomCardSVG />;

export default CustomCard;
